import { usePathname, useRouter, useSearchParams } from "next/navigation";

import useGetSearchParamValues from "@/hooks/useGetSearchParamValues";
import toggleURLSearchParamValue from "@/utils/toggleURLSearchParamValue";

import FilterShortcut from "@/components/botanic/FilterShortcut";
import { AvailableFilter, FilterType } from "@/components/DynamicFilters/types";

import { useMobileFilterModalContext } from "../../MobileFilterModalUI";

const MobileMenuFilterShortcuts = ({
  availableFilters,
  setOpenFilterSection,
  filterQueryStringKey = (qsKey) => qsKey,
}: {
  availableFilters: AvailableFilter[];
  setOpenFilterSection: (filterName?: string) => void;
  filterQueryStringKey?: (qsKey: string) => string;
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { push } = useRouter();
  const { setModalActive } = useMobileFilterModalContext();
  const getSearchParamValues = useGetSearchParamValues();

  const targetURLSearchParams = new URLSearchParams(searchParams?.toString());
  // * Remove pagination params when clicking fulfillment filter link.
  targetURLSearchParams.delete("page");

  const nonAppliedFilterCategories = availableFilters.filter(
    (available) =>
      getSearchParamValues(filterQueryStringKey(available.name)).length === 0,
  );

  return nonAppliedFilterCategories.length > 0
    ? nonAppliedFilterCategories.map((filter, i) => (
        <FilterShortcut
          key={`${filter.name}_${i}`}
          text={filter.label}
          showChevron={filter.type !== FilterType.toggle}
          onClick={() => {
            if (filter.type === FilterType.toggle) {
              // * Shortcuts for toggle filters just apply the toggle, no need to open the modal.
              const queryString = toggleURLSearchParamValue(
                targetURLSearchParams,
                filterQueryStringKey(filter.name),
                "true",
              ).toString();
              push(`${pathname}${queryString ? `?${queryString}` : ""}`);
            } else {
              setOpenFilterSection(filter.name);
              setModalActive(true);
            }
          }}
        />
      ))
    : null;
};

export default MobileMenuFilterShortcuts;
